/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonskindinstagram3Inputs */

const en_listingbuttonskindinstagram3 = /** @type {(inputs: Listingbuttonskindinstagram3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram`)
};

const de_listingbuttonskindinstagram3 = /** @type {(inputs: Listingbuttonskindinstagram3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram`)
};

/**
* | output |
* | --- |
* | "Instagram" |
*
* @param {Listingbuttonskindinstagram3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonskindinstagram3 = /** @type {((inputs?: Listingbuttonskindinstagram3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonskindinstagram3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonskindinstagram3(inputs)
	return de_listingbuttonskindinstagram3(inputs)
});
export { listingbuttonskindinstagram3 as "listingButtonsKindInstagram" }